"use client";

import React from "react";
import Link from "next/link";
import Image from "next/image";
import { Button } from "./ui/Button";
import { Sparkles } from "lucide-react";

export function Header() {
  return (
    <header className="sticky top-0 z-50 w-full bg-paper/90 backdrop-blur-md border-b border-line/60">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 sm:h-20 flex items-center justify-between gap-2">
        {/* Wordmark */}
        <Link href="/" aria-label="Curated Den home" className="flex min-w-0 items-center gap-1 sm:gap-2 group">
          <Image src="/logo.png" alt="" width={56} height={56} sizes="(max-width: 639px) 36px, 56px" loading="eager" className="h-9 w-9 sm:h-14 sm:w-14 shrink-0" />
          <span className="whitespace-nowrap font-serif text-lg sm:text-3xl font-bold tracking-tight text-ink group-hover:text-clay transition-colors">
            Curated Den
          </span>
        </Link>

        {/* Navigation links */}
        <nav className="hidden lg:flex items-center gap-8 text-sm font-medium text-ink-soft">

          <Link href="/#how-it-works" className="hover:text-ink transition-colors">
            How it works
          </Link>
          <Link href="/#styles" className="hover:text-ink transition-colors">
            Styles
          </Link>
          <Link href="/#consult" className="hover:text-ink transition-colors">
            Designer Consult
          </Link>
        </nav>

        {/* Action Button */}
        <div className="flex shrink-0 items-center gap-3">
          <Link href="/design" aria-label="Design my room">
            <Button size="md" className="gap-1.5 px-3 sm:px-5 whitespace-nowrap text-xs sm:text-sm">
              <Sparkles className="w-3.5 h-3.5" />
              <span className="sm:hidden">Design a room</span><span className="hidden sm:inline">Design my room</span>
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
}
